import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const OtpPage = () => {
  const location = useLocation();
  return <Navigate to="/login" replace state={{ email: location.state?.email || '' }} />;
};

export default OtpPage;
